import { Component } from '@angular/core';

@Component({
  selector: 'true-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false
})
export class LandingComponent { }
